import ContractsMileageDetailsResponse from "../../../../api/raily/contracts/mileage/details/contracts-mileage-details.response";
import ContractsMileageDetails from "./contracts-mileage-details";

const create = (
  response: ContractsMileageDetailsResponse,
): ContractsMileageDetails => {
  return {
    distanceRateCompanyVehicle: response.data.distanceRateCompanyVehicle,
    distanceRateCarGt900cm3: response.data.distanceRateCarGt900cm3,
    distanceRateCarLe900cm3: response.data.distanceRateCarLe900cm3,
    distanceRateMotorcycle: response.data.distanceRateMotorcycle,
    distanceRateMoped: response.data.distanceRateMoped,
    dietFullRate: response.data.dietFullRate,
    dietFullAfterHours: response.data.dietFullAfterHours,
    dietHalfRate: response.data.dietHalfRate,
    dietHalfAfterHours: response.data.dietHalfAfterHours,
    validSince: response.data.validSince,
    validTo: response.data.validTo,
    isActive: !response.data.disabled,
    companyName: response.data.companyName,
  };
};

const contractsMileageDetailsFactory = {
  create,
};

export default contractsMileageDetailsFactory;
